import { AxiosResponse } from 'axios';
import { ReactNode, createContext, useState } from 'react';
import api from "../services/api";

interface AuthContextData {
  token: string;
  validatedToken: string,
  userData: UserData;
  LogIn(email: string, password: string): Promise<AxiosResponse | null>;
  LogOut(): void;
  ValidateLogin(): Promise<boolean>;
  IsLogged(): boolean;
}

export interface AuthProviderProps {
  children: ReactNode[];
}

export interface UserData {
  job: string;
  userName: string;
  company: string;
  companyId: number;
}

export interface LoginResponse {
  token: string;
  accountType: number;
  userName: string;
  company: string;
  companyId: number;
  adminData: {
    job: string;
    adminId: number;
  }
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export function AuthProvider({ children }: AuthProviderProps) {

  const [userData, setUserData] = useState(GetSavedUserData());
  const [token, setToken] = useState(GetSavedToken() || '');
  ///TODO: Validar automaticamente, e não externamente 
  const [validatedToken, setValidatedToken] = useState(GetValidatedToken() || '');

  function GetSavedUserData(): UserData {
    let savedData = localStorage.getItem("userData");
    try {
      if (savedData) {
        let data: UserData = JSON.parse(savedData);
        return data;
      }
      return {} as UserData;
    }
    catch {
      return {} as UserData;
    }
  }

  function GetSavedToken() {
    const sessionToken = sessionStorage.getItem("tokenValidated");
    if (sessionToken != null && sessionToken !== "") {
      api.defaults.headers['Authorization'] = `Bearer ${sessionToken}`;
      return sessionToken;
    }

    const token = localStorage.getItem("token");
    if (token != null && token !== '')
      api.defaults.headers['Authorization'] = `Bearer ${token}`;
    return token;
  }

  function GetValidatedToken() {
    const sessionToken = sessionStorage.getItem("tokenValidated");
    if (sessionToken != null && sessionToken !== '') {
      api.defaults.headers['Authorization'] = `Bearer ${sessionToken}`;
    }
    return sessionToken;
  }

  async function LogIn(email: string, password: string): Promise<AxiosResponse | null> {
    console.log("Rodando login");

    try {
      ///Se a resposta não tiver no range dos 200, lança exceção
      const response = await api.post("/auth/login", { email, password });

      let data: LoginResponse = response.data;
      let userData = {
        job: data.adminData.job,
        company: data.company,
        companyId: data.companyId,
        userName: data.userName,
      };
      setToken(data.token);
      setUserData(userData);
      console.log("User data: ", userData);

      api.defaults.headers['Authorization'] = `Bearer ${data.token}`;
      localStorage.setItem("token", data.token);
      localStorage.setItem("userData", JSON.stringify(userData));

      return response;
    }
    catch {
      console.log("Erro ao fazer login");
      return null;
    }

  }

  function LogOut() {
    console.log("Log out");
    localStorage.setItem("token", '');
    sessionStorage.setItem("tokenValidated", "");
    setToken('');
  }

  async function ValidateLogin(): Promise<boolean> {
    try {
      if (validatedToken !== "")
        return true;

      console.log("Fazendo request de validação do token");
      const response = await api.post("/auth/validateTokenAdmin");
      const valid = response.data.valid;
      if (valid) {
        setValidatedToken(token);
        sessionStorage.setItem("tokenValidated", token);
      }
      return valid;
    }
    catch (error) {
      console.error("Erro validando token:", error);
      return false;
    }
  }


  function IsLogged(): boolean {
    return token != null && token !== '';
  }


  return (
    <AuthContext.Provider value={{ token, validatedToken, userData, LogIn, LogOut, ValidateLogin, IsLogged }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;